export const PAYOUTS = '/static/images/icons/payouts.png';
export const PAYOUTS_HOVER = '/static/images/icons/payouts-hover.png';
export const TRANSACTIONS = '/static/images/icons/transactions.png';
export const SETTINGS = '/static/images/icons/settings.png';
export const SETTINGS_HOVER = '/static/images/icons/settings-hover.png';
export const TRANSACTIONS_HOVER = '/static/images/icons/transactions-hover.png';
export const PREVIEW_PAY_BILL = '/static/images/preview-pay-bill.svg';
export const DOCUMENTATION = '/static/images/documentation.png';
export const DRIVERLICENCE = '/static/images/driverLicence.png';
export const PASSPORT = '/static/images/passport.png';
export const BANK_STATEMENT = '/static/images/bankstatement.png';
export const CHECK = '/static/images/icons/check.svg';
export const COPY = '/static/images/icons/copy.svg';
export const COPY_WHITE = '/static/images/icons/copy-white.svg';
export const SHARE = '/static/images/icons/share.svg';
export const DOWNLOAD = '/static/images/icons/download.svg';
export const SHOP = '/static/images/icons/shop.svg';
export const ALERT_CIRCLE = '/static/images/icons/alert-circle.svg';
